import React from 'react';
import Chat from './components/chat';

function App() {
  return <Chat />;
}

export default App;
